import Axios from "axios";
import { action, decorate, observable } from "mobx";

export default class ManageMobileTrainingVideosStore {
    list_data = null;
    getList = (conditional = {}) => {
        return Axios.post(`help/help-items/mobile-video-list`, conditional).then(({ data }) => {
            this.list_data = data.list;
        });
    };
}

decorate(ManageMobileTrainingVideosStore, {
    list_data: observable,
    getList: action,
});
